/** URLS used throughout packages */
export const urls = {
  ACCOUNT_DISCOVERY_URL: '/api/v4/account-discovery',
  ACCOUNT_LOCKED_URL: '/app/login/locked',
  ACTIVATE_ACCOUNT_URL: '/app/login/activate',
  COOKIE_ERROR_URL: '/app/login/cookies-disabled',
  COMPANY_PLAN_URL: '/companies',
  TEAMS_COMPANIES_PLAN_URL: '/teams-companies',
  CSRF_URL: '/api/v3/csrf',
  CURRENT_SESSION_URL: '/api/v4/session',
  DEFAULT_LOGIN_NEXT: '/app/home',
  DEFAULT_SIGNUP_NEXT: '/app/onboarding',
  DOMAIN_DISCOVERY_URL: '/api/v4/domain-discovery',
  ENTERPRISE_PLAN_URL: '/enterprise',
  IFRAME_DEFAULT_SIGNUP_NEXT: '/app/home',
  FORGOT_PASSWORD_URL: '/app/login/forgot',
  FORGOT_PASSWORD_API_URL: '/api/v3/accounts/password/forgot',
  HELP_URL: '/app/get-help',
  INDEX_URL: '/',
  INVITATION_API_URL: '/api/v4/invitations',
  LEGAL_URL: '/legal',
  LOGIN_API_URL: '/api/v3/login',
  // The sign-in code step, for a login the new-device check challenged:
  // submit a code, or ask for a new one
  LOGIN_DEVICE_CONFIRMATIONS_API_URL: '/api/v4/login/device-confirmations',
  LOGIN_DEVICE_CODES_API_URL: '/api/v4/login/device-codes',
  LOGIN_URL: '/app/login',
  LOGIN_WITH_SSO_URL: '/app/login/sso',
  LOGOUT_API_URL: '/api/logout',
  MFA_URL: '/app/login/2fa',
  PENDING_WORKSPACE_ACCESS_URL: '/app/login/pending-workspace-access',
  PRIVACY_URL: '/privacy',
  REAUTHENTICATE_URL: '/app/login/reauthenticate',
  RESEND_VERIFICATION_API_URL: '/api/v3/resend-signup-verification',
  RESET_PASSWORD_API_URL: '/api/v3/accounts/password/reset',
  RESET_PASSWORD_URL: '/app/login/reset-password',
  SIGNUP_API_URL: '/api/v3/profiles',
  SIGNUP_URL: '/sign-up',
  TWO_FACTOR_AUTH_API_URL: '/api/v3/2fa',
  TWO_FACTOR_URL: '/app/login/2fa',
  // Email verification gating page
  VERIFY_EMAIL_URL: '/sign-up/verify-email',
  // Email verification token landing page
  VERIFY_SIGNUP_URL: '/sign-up/verify',
  VERIFY_SIGNUP_EXPIRED_URL: '/sign-up/verify/link-expired',
  VERIFY_SIGNUP_API_URL: '/api/v3/verify-signup',
  ZAP_TEMPLATE_API_URL: '/api/v4/guided-recipes',
  SECURITY_HEADERS_URL: '/api/v4/security/domain/headers/',
  REDIRECT_URL: '/redirect',
};
